import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { Auth } from "app/js/src/infrastructure/auth";
import { environment } from "app/environments/environment";
import { IGenerateMetadataRepository } from "app/js/src/domain/clipping-studio/publish/i-generate-metadata-repository";
import { GenerateMetadataResponse } from "app/js/src/domain/clipping-studio/publish/publish-models";

const GENERATE_METADATA_URL = `${environment.ENDPOINT}/api/AiAssistant/generate-metadata`;

@Injectable()
export class ClippingStudioGenerateMetadataRepositoryService extends IGenerateMetadataRepository {
  constructor(
    private http: HttpClient,
    private auth: Auth,
  ) {
    super();
  }

  private getHeaders(): HttpHeaders {
    const token = this.auth.token;
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (token) {
      headers = headers.set(
        "Authorization",
        `${token.tokenType} ${token.token}`,
      );
    }
    return headers;
  }

  async generateMetadata(
    videoName: string,
    options?: { allowedRatings?: string[]; destination?: string },
  ): Promise<GenerateMetadataResponse> {
    const body: { videoName: string; allowedRatings?: string[]; destination?: string } = {
      videoName: videoName.trim(),
    };
    if (options?.allowedRatings?.length) {
      body.allowedRatings = options.allowedRatings;
    }
    if (options?.destination?.trim()) {
      body.destination = options.destination.trim();
    }
    const response = await firstValueFrom(
      this.http.post(GENERATE_METADATA_URL, body, {
        headers: this.getHeaders(),
        responseType: "text",
      }),
    );
    if (!response) {
      throw new Error("Empty response from generate-metadata");
    }
    const parsed = JSON.parse(response) as GenerateMetadataResponse;
    return {
      title: parsed.title ?? "",
      tags: parsed.tags ?? "",
      message: parsed.message ?? "",
    };
  }
}
